import React from 'react';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import { CourseProvider } from '../../context/CourseContext';
import Header from '../Header/Header';
import { getStyles } from './styles';
import ProvisionCoursesPanel from './ProvisionCoursesPanel';
import ProvisionCoursesSheet from './ProvisionCoursesSheet';

export default function ProvisionCourses() {
  const theme = useTheme();
  const styles = getStyles(theme);

  return (
    <CourseProvider>
      <Box sx={styles.root}>
        <Header />
        <ProvisionCoursesPanel />
        <ProvisionCoursesSheet />
      </Box>
    </CourseProvider>
  );
}
